import React from "react";
import { styled } from '@mui/material/styles';
import faqsStyles from './FAQsStyles';
import Accordion from "../Accordion/Accordion";
import Separator from "../Separator/Separator";

type FAQsProps = {
  slots: Array<{
    title: string;
    content: string;
  }>;
};

const StyledFAQs = styled('section')(({ theme }) => faqsStyles(theme));

const Template: React.FC<FAQsProps> = ({ slots }) => (
  <StyledFAQs className="flex-col px-8 items-center flex" id="faqs-section">
    <div className='w-full flex justify-center'>
      <h2 className="container pt-[4rem] lg:pt-[8rem] text-4xl lg:text-6xl font-semibold text-center pb-[2rem] lg:pb-[1.5rem] text-wrap w-fit">Preguntas frecuentes</h2>
    </div>
    <Separator className="mt-2 mb-12 lg:mt-2 lg:mb-12"/>
    <div className="mb-24 lg:mb-36">
      <Accordion 
        className="w-full"
        slots={slots}
      />
    </div>
  </StyledFAQs>
);

export default Template;